module.exports = __webpack_public_path__ + "static/2-fd976c87eac204b88ec4fe51a0b5fadf.png";